import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import { invoicesActions } from 'src/store/modules/invoices';
import {
  IFiltersInvoice,
  IPaginationInvoice
} from 'src/services/invoice/InvoiceService';
import InvoiceMobileFilters from './InvoiceMobileFilters';

const mapDispatchToProps = (dispatch: any) => ({
  getInvoices: (filters: IFiltersInvoice, pagination: IPaginationInvoice) =>
    dispatch(invoicesActions.getInvoices(filters, pagination))
});

export const pureComponent = InvoiceMobileFilters;
export default connect(
  null,
  mapDispatchToProps
)(withI18n()(InvoiceMobileFilters));
